import CryptoJS from 'crypto-js';
import { bizBaseUrl, merchantKey, merchantPid, payBaseUrl, webBaseUrl } from 'services/request';

export type VPayRequestDT = {
  merchantPid: string; // 商户ID
  merchantKey: string; // 通讯密钥
  payUrl?: string; // 支付地址
  payType: string; // 根据 `payMode.current` 的实际类型进行调整
  outTradeNo: string; // 商户订单号（建议不重复）
  productName: string;
  productMoney: number;
  signType: string;
  sign?: string;
  // 所有参数都会原样传递给notifyUrl和returnUrl（会自动添加trade_no）
  // notifyUrl: 后端收到异步通知后 -> 修改订单支付成功
  // returnUrl: 检测到支付跳转页面 -> 通过商户订单号再次检测支付状态，升级会员
  notifyUrl: string; // 异步通知地址
  returnUrl: string; // 同步跳转地址
};

export type VPayAccessDT = {
  name: string;
  money: number;
  notify_url: string;
  return_url: string;
  pid: string;          // 商户号
  trade_no: string;     // 系统订单号
  out_trade_no: string; // 商户订单号
  type: string;         // 支付类型：alipay，wxpay
  trade_status: string; // 支付状态：TRADE_SUCCESS已支付
  sign: string;         // 签名
  sign_type: string;    // 签名类型：默认md5
};

export const getVPayData = (
  payType: string,
  outTradeNo: string,
  productName: string,
  productMoney: number
): VPayRequestDT => {
  return {
    merchantPid: merchantPid,
    merchantKey: merchantKey,
    payUrl: payBaseUrl,
    payType: payType,
    outTradeNo: outTradeNo,
    productName: productName,
    productMoney: productMoney,
    signType: 'MD5',
    notifyUrl: `${bizBaseUrl}/usr/payOrder/vPayAsyncNotify`,
    returnUrl: `${webBaseUrl}/success`,
  };
};

const getParams = (data: VPayRequestDT) => {
  // 按顺序拼接参数
  const params = `money=${data.productMoney}&name=${data.productName}&notify_url=${data.notifyUrl}&out_trade_no=${data.outTradeNo}&pid=${data.merchantPid}&return_url=${data.returnUrl}&sitename=${data.payUrl}&type=${data.payType}`;
  return params;
};

export const getSign = (data: VPayRequestDT) => {
  const params = getParams(data);
  // 参数+key
  const stringToEncrypt = `${params}${data.merchantKey}`;
  // MD5加密
  const md5Hash = CryptoJS.MD5(stringToEncrypt).toString();
  return md5Hash;
};

export const getUrl = (data: VPayRequestDT) => {
  const params = getParams(data);
  const sign = getSign(data);
  const url = `${data.payUrl}/submit.php?${params}&sign_type=${data.signType}&sign=${sign}`;
  return url;
};
